<template>
  <cargo-advance-select
    :multiple="multiple"
    :default-value="multiple ? '' : value"
    :default-multiple-value="multiple ? value : []"
    callback-method-type="value"
    v-bind="$attrs"
    v-on="$listeners"
    @parentCallBack="onParentCallBack"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'CargoAdvanceSelectStandard',
  components: {
    cargoAdvanceSelect
  },
  props: {
    multiple: { type: Boolean, default: false }, // （是否多选）
    value: { type: [String, Number, Boolean, Array], required: true }
  },
  methods: {
    onParentCallBack(data) {
      let newValue = data instanceof Object ? data.value : data
      if (newValue === undefined) {
        newValue = ''
      }
      if (newValue === '') {
        if (typeof this.value === 'number') {
          newValue = 0
        }
      }
      if (newValue !== this.value) {
        this.$emit('input', newValue)
        this.$emit('change', newValue)
      }
    }
  }
}
</script>
